const contactHero=()=>{
    return(
        <>
            <div className="container-fluid">
                <div className="container contactheroimg">
                    
                </div>

                <h1 className="display-1 mobileTextcontactheader" style={{position:'absolute', color:'#ffffff', marginLeft:'550px', marginTop:'-370px', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>CONTACT</h1>

            </div>
        </>
    )
}
export default contactHero